import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const STATS = [
  { label: 'Anrufe heute', value: '0', sub: 'Noch keine Aktivität' },
  { label: 'Anrufe gesamt', value: '0', sub: 'Dieser Monat' },
  { label: 'Termine gebucht', value: '0', sub: 'Dieser Monat' },
  { label: 'Weitergeleitete Anrufe', value: '0', sub: 'Dieser Monat' },
];

function DashboardPage() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  const emailInitial = user?.email ? user.email[0].toUpperCase() : '?';

  return (
    <div style={styles.root}>
      {/* SIDEBAR */}
      <aside style={styles.sidebar}>
        <div style={styles.sidebarLogo} onClick={() => navigate('/')}>
          <img src="/logo-frontup.png" style={{width:30,height:30,borderRadius:7,objectFit:'cover'}} alt="FrontUp" />
          <span style={styles.sidebarLogoName}>FrontUp</span>
        </div>

        <nav style={styles.sideNav}>
          {[
            { label: 'Dashboard', icon: GridIcon, active: true },
            { label: 'KI-Agenten', icon: BotIcon, active: false },
            { label: 'Anrufe', icon: PhoneIcon, active: false },
            { label: 'Termine', icon: CalIcon, active: false },
            { label: 'Einstellungen', icon: SettingsIcon, active: false },
          ].map(item => (
            <button
              key={item.label}
              style={{...styles.sideNavItem, ...(item.active ? styles.sideNavItemActive : {})}}
            >
              <item.icon active={item.active} />
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div style={styles.sidebarBottom}>
          <div style={styles.userRow}>
            <div style={styles.avatar}>{emailInitial}</div>
            <div style={styles.userInfo}>
              <div style={styles.userEmail}>{user?.email}</div>
              <div style={styles.userPlan}>Starter Plan</div>
            </div>
          </div>
          <button onClick={handleSignOut} style={styles.logoutBtn}>
            <LogoutIcon />
            Abmelden
          </button>
        </div>
      </aside>

      {/* MAIN */}
      <main style={styles.main}>
        <div style={styles.topBar}>
          <div>
            <h1 style={styles.pageTitle}>Dashboard</h1>
            <p style={styles.pageSub}>Willkommen zurück, {user?.email?.split('@')[0]}.</p>
          </div>
          <button onClick={() => navigate('/demo-buchen')} style={styles.ctaBtn}>
            Demo buchen
          </button>
        </div>

        {/* STATS GRID */}
        <div style={styles.statsGrid}>
          {STATS.map((s, i) => (
            <div key={i} style={styles.statCard}>
              <div style={styles.statValue}>{s.value}</div>
              <div style={styles.statLabel}>{s.label}</div>
              <div style={styles.statSub}>{s.sub}</div>
            </div>
          ))}
        </div>

        {/* EMPTY STATE */}
        <div style={styles.emptyCard}>
          <div style={styles.emptyIcon}>
            <BotIcon active />
          </div>
          <h2 style={styles.emptyTitle}>Willkommen bei FrontUp</h2>
          <p style={styles.emptySub}>Buche eine Demo und wir richten deinen KI-Agenten gemeinsam ein.</p>
          <button onClick={() => navigate('/preise')} style={styles.emptyBtn}>
            Ersparnis berechnen
          </button>
        </div>

        {/* QUICK LINKS */}
        <div style={styles.quickGrid}>
          {[
            { title: 'Demo buchen', desc: '20 Min. persönliches Gespräch', onClick: () => navigate('/demo-buchen') },
            { title: 'Preise ansehen', desc: 'Plan upgraden oder wechseln', onClick: () => navigate('/preise') },
            { title: 'Passwort ändern', desc: 'Sicherheit deines Accounts', onClick: () => navigate('/reset-password') },
          ].map((q, i) => (
            <div key={i} onClick={q.onClick} style={styles.quickCard}>
              <div style={styles.quickTitle}>{q.title}</div>
              <div style={styles.quickDesc}>{q.desc}</div>
              <div style={styles.quickArrow}>→</div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

/* ── INLINE ICONS ─────────────────────────────── */
function GridIcon({ active }) {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none"
      stroke={active ? '#fff' : 'rgba(255,255,255,.4)'} strokeWidth="2">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
      <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
    </svg>
  );
}
function BotIcon({ active }) {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none"
      stroke={active ? '#fff' : 'rgba(255,255,255,.4)'} strokeWidth="2">
      <rect x="3" y="11" width="18" height="10" rx="2"/>
      <path d="M12 11V7m-4 4V9m8 2V9M8 21v-2m8 2v-2"/>
      <circle cx="12" cy="5" r="2"/>
    </svg>
  );
}
function PhoneIcon({ active }) {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none"
      stroke={active ? '#fff' : 'rgba(255,255,255,.4)'} strokeWidth="2">
      <path d="M22 16.92v3a2 2 0 01-2.18 2A19.79 19.79 0 013.09 5.18 2 2 0 015.09 3h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L9.09 10.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
    </svg>
  );
}
function CalIcon({ active }) {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none"
      stroke={active ? '#fff' : 'rgba(255,255,255,.4)'} strokeWidth="2">
      <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/>
      <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  );
}
function SettingsIcon({ active }) {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none"
      stroke={active ? '#fff' : 'rgba(255,255,255,.4)'} strokeWidth="2">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
    </svg>
  );
}
function LogoutIcon() {
  return (
    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
      <polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  );
}

/* ── STYLES ───────────────────────────────────── */
const styles = {
  root: {
    display: 'flex',
    minHeight: '100vh',
    background: '#f7f7f7',
  },
  sidebar: {
    width: 240,
    background: '#111',
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 16px',
    position: 'sticky',
    top: 0,
    height: '100vh',
    flexShrink: 0,
  },
  sidebarLogo: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 36,
    cursor: 'pointer',
    padding: '0 8px',
  },
  sidebarLogoName: {
    fontSize: 17,
    fontWeight: 800,
    letterSpacing: '-.5px',
    color: '#fff',
  },
  sideNav: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    flex: 1,
  },
  sideNavItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '10px 12px',
    borderRadius: 9,
    border: 'none',
    background: 'none',
    color: 'rgba(255,255,255,.45)',
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'inherit',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'background .1s, color .1s',
  },
  sideNavItemActive: {
    background: 'rgba(255,255,255,.1)',
    color: '#fff',
  },
  sidebarBottom: {
    borderTop: '1px solid rgba(255,255,255,.08)',
    paddingTop: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  userRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '8px',
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    background: 'rgba(255,255,255,.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: 700,
    color: '#fff',
    flexShrink: 0,
  },
  userInfo: {
    overflow: 'hidden',
  },
  userEmail: {
    fontSize: 12,
    color: 'rgba(255,255,255,.7)',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  userPlan: {
    fontSize: 11,
    color: 'rgba(255,255,255,.3)',
  },
  logoutBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '9px 12px',
    background: 'none',
    border: 'none',
    color: 'rgba(255,255,255,.35)',
    fontSize: 13,
    fontFamily: 'inherit',
    cursor: 'pointer',
    borderRadius: 8,
    transition: 'color .15s',
    textAlign: 'left',
  },
  main: {
    flex: 1,
    padding: '48px',
    maxWidth: 1000,
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 40,
  },
  pageTitle: {
    fontSize: 28,
    fontWeight: 800,
    letterSpacing: '-1px',
    color: '#111',
    marginBottom: 4,
  },
  pageSub: {
    fontSize: 15,
    color: '#888',
  },
  ctaBtn: {
    padding: '11px 22px',
    background: '#111',
    color: '#fff',
    border: 'none',
    borderRadius: 9,
    fontSize: 14,
    fontWeight: 700,
    fontFamily: 'inherit',
    cursor: 'pointer',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4,1fr)',
    gap: 14,
    marginBottom: 28,
  },
  statCard: {
    background: '#fff',
    border: '1.5px solid #e5e5e5',
    borderRadius: 14,
    padding: '22px 20px',
  },
  statValue: {
    fontSize: 32,
    fontWeight: 800,
    letterSpacing: '-1.5px',
    color: '#111',
    lineHeight: 1,
    marginBottom: 6,
  },
  statLabel: {
    fontSize: 13,
    fontWeight: 600,
    color: '#333',
    marginBottom: 3,
  },
  statSub: {
    fontSize: 12,
    color: '#aaa',
  },
  emptyCard: {
    background: '#fff',
    border: '1.5px solid #e5e5e5',
    borderRadius: 16,
    padding: '48px 40px',
    textAlign: 'center',
    marginBottom: 24,
  },
  emptyIcon: {
    width: 56,
    height: 56,
    background: '#111',
    borderRadius: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
  },
  emptyTitle: {
    fontSize: 22,
    fontWeight: 800,
    letterSpacing: '-.5px',
    color: '#111',
    marginBottom: 8,
  },
  emptySub: {
    fontSize: 15,
    color: '#888',
    maxWidth: 400,
    margin: '0 auto 28px',
    lineHeight: 1.6,
  },
  emptyBtn: {
    padding: '13px 28px',
    background: '#111',
    color: '#fff',
    border: 'none',
    borderRadius: 9,
    fontSize: 15,
    fontWeight: 700,
    fontFamily: 'inherit',
    cursor: 'pointer',
    marginRight: 10,
  },
  emptyBtnSecondary: {
    padding: '12px 28px',
    background: 'transparent',
    color: '#555',
    border: '1.5px solid #e5e5e5',
    borderRadius: 9,
    fontSize: 15,
    fontWeight: 600,
    fontFamily: 'inherit',
    cursor: 'pointer',
  },
  quickGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    gap: 14,
  },
  quickCard: {
    background: '#fff',
    border: '1.5px solid #e5e5e5',
    borderRadius: 14,
    padding: '22px 20px',
    cursor: 'pointer',
    transition: 'border-color .15s',
    position: 'relative',
  },
  quickTitle: {
    fontSize: 15,
    fontWeight: 700,
    color: '#111',
    marginBottom: 4,
  },
  quickDesc: {
    fontSize: 13,
    color: '#888',
  },
  quickArrow: {
    position: 'absolute',
    top: 20,
    right: 20,
    fontSize: 16,
    color: '#ccc',
  },
};

export default DashboardPage;
